import React, { useState } from 'react'
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../common/AdminSidebar';
import DeletePopup from '../DeletePopup';
import AttachmentView from '../AttachmentView';
import ConfirmPopup from '../ConfirmPopup';
import { TopBar } from '../common/Topbar';
import { Profile } from '../../pages/profile/Profile';
import { GlobalTenantBanner } from '../GlobalTenantBanner';
import { TenantSubscriptionBanner } from '../TenantSubscriptionBanner';

export const AdminMainLayout = () => {
  const [fullScreen, setFullScreen] = useState<boolean>(true);

  const handleScreen = () => {
    setFullScreen(!fullScreen);
  }

  return (
    <div className="flex">
      <AdminSidebar handleScreen={handleScreen} />

      <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max`}>
        <TopBar />

        <Profile />

        <DeletePopup />

        <GlobalTenantBanner />

        <TenantSubscriptionBanner />

        <ConfirmPopup />

        <AttachmentView />

        <Outlet />
      </div>

    </div>
  );
}
